// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"72225b72","591":"8e265d20","680":"8c1becb1"}[chunkId] + ".chunk.js";
};